import type { OnyxTableNotFound } from '@onyx/angular';

const I18N = 'bases.assignedDrivers.empty';

export const BASE_ASSIGNED_DRIVERS_NOT_FOUND: OnyxTableNotFound = {
  icon: { name: 'two-users-filled', size: 32 },
  title: `${I18N}.title`,
  text: `${I18N}.text`,
};
